import dynamic from 'next/dynamic';

import { ContentItemUITemplateKeys } from '@/interfaces';

export const UITemplatesContentItem: {
  // biome-ignore lint/suspicious/noExplicitAny: dynamic component map requires any props
  [key in ContentItemUITemplateKeys]: React.ComponentType<any>;
} = {
  [ContentItemUITemplateKeys.BulletPoints]: dynamic(
    async () => import('../components/ContentItem/Templates/BulletPoints'),
  ),
  [ContentItemUITemplateKeys.Metrics]: dynamic(async () => import('../components/ContentItem/Templates/Metrics')),
  [ContentItemUITemplateKeys.Services]: dynamic(async () => import('../components/ContentItem/Templates/Services')),
};
